export { default as ReferralInfo } from './referral-info/Main.vue';
export { default as Binnacle } from './binnacle/Main.vue';
export { default as Documents } from './documents/Main.vue';
export { default as Signature } from './signature/Main.vue';
